import React from 'react';

import useCustomerWishlist from '@src/hooks/useCustomerWishlist';
import useCurrentTextStyle from '@src/hooks/useCurrentTextStyle';
import { IRemovedCartItem } from '@src/hooks/useCartItemRemoval';

interface CartUndoWishlistPopupProps {
  item: IRemovedCartItem;
  settings: any; // Settings from itemsBlock or block settings
  onClickUndo: () => void;
  onClickWishlist: () => void;
  initialWishlistState: boolean;
  type?: 'minicart' | 'cart';
}

const CartUndoWishlistPopup = ({
  item,
  settings,
  onClickUndo,
  onClickWishlist,
  initialWishlistState,
  type = 'minicart'
}: CartUndoWishlistPopupProps) => {
  const { isProductInWishlist } = useCustomerWishlist();
  const { getCurrentTextStyle } = useCurrentTextStyle();

  console.log(settings);

  // Extract settings with defaults
  const background = settings?.undo_wishlist_popup_background_color || '#f3f4f6';
  const removedText =
    settings?.undo_wishlist_popup_removed_text?.replace('{product_title}', item.product_title) ||
    `Removed "${item.product_title}"`;
  const undoText = settings?.undo_wishlist_popup_undo_text || 'Undo';
  const wishlistText = settings?.undo_wishlist_popup_wishlist_text || 'Save to wishlist';

  // Get responsive text styles
  const removedTextStyle = getCurrentTextStyle(
    settings?.undo_wishlist_popup_removed_text_style || 'b8--regular',
    settings?.undo_wishlist_popup_removed_text_style_enable_responsive,
    settings?.undo_wishlist_popup_removed_text_style_mobile,
    settings?.undo_wishlist_popup_removed_text_style_tablet,
    settings?.undo_wishlist_popup_removed_text_style_ultrawide
  );

  const undoTextStyle = getCurrentTextStyle(
    settings?.undo_wishlist_popup_undo_text_style || 'b8--bold',
    settings?.undo_wishlist_popup_undo_text_style_enable_responsive,
    settings?.undo_wishlist_popup_undo_text_style_mobile,
    settings?.undo_wishlist_popup_undo_text_style_tablet,
    settings?.undo_wishlist_popup_undo_text_style_ultrawide
  );

  const wishlistTextStyle = getCurrentTextStyle(
    settings?.undo_wishlist_popup_wishlist_text_style || 'b8--bold',
    settings?.undo_wishlist_popup_wishlist_text_style_enable_responsive,
    settings?.undo_wishlist_popup_wishlist_text_style_mobile,
    settings?.undo_wishlist_popup_wishlist_text_style_tablet,
    settings?.undo_wishlist_popup_wishlist_text_style_ultrawide
  );

  return (
    <div
      className='undo-wishlist-popup rounded-lg flex items-start justify-between px-4 py-3 gap-x-2'
      style={{ backgroundColor: background }}
    >
      <div className={`undo-wishlist-popup__removed-text basis-2/3 grow ${removedTextStyle}`}>{removedText}</div>

      <div
        className={`${
          type === 'minicart' ? 'basis-1/3' : ''
        } min-w-[99px] lg:min-w-[117px] shrink-0 flex justify-start`}
      >
        <div className='flex flex-col gap-y-2'>
          <button
            className={`undo-wishlist-popup__undo-button text-left flex gap-x-2 link ${undoTextStyle}`}
            onClick={onClickUndo}
          >
            <i className='icon icon-rotate text-[16px]'></i>
            <span className='underline'>{undoText}</span>
          </button>

          {!initialWishlistState && (
            <button
              className={`undo-wishlist-popup__wishlist-button text-left flex gap-x-2 link ${wishlistTextStyle}`}
              onClick={onClickWishlist}
            >
              <i
                className={`icon text-[16px] ${isProductInWishlist(item.product_id) ? 'icon-heart-filled' : 'icon-heart'}`}
              ></i>
              <span className='underline'>{wishlistText}</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CartUndoWishlistPopup;
